module.exports = __webpack_public_path__ + "img/user-portfolio-mobile@3x.c6165d4.png";